import { render, staticRenderFns } from "./editordesc.vue?vue&type=template&id=6b0e42e4"
import script from "./editordesc.vue?vue&type=script&lang=js"
export * from "./editordesc.vue?vue&type=script&lang=js"
import style0 from "./editordesc.vue?vue&type=style&index=0&id=6b0e42e4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports